import { render, staticRenderFns } from "./MaintenanceNotification.vue?vue&type=template&id=78a3c2d9&scoped=true"
import script from "./MaintenanceNotification.vue?vue&type=script&lang=js"
export * from "./MaintenanceNotification.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceNotification.vue?vue&type=style&index=0&id=78a3c2d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a3c2d9",
  null
  
)

export default component.exports